(() => {
  const initRajSingleProduct = (section) => {
    if (!section || section.dataset.rajSpReady === 'true') return;
    section.dataset.rajSpReady = 'true';

    const variantsNode = section.querySelector('[data-raj-sp-variants]');
    const moneyNode = section.querySelector('[data-raj-sp-money-format]');
    const form = section.querySelector('[data-raj-sp-form]');
    const variantInput = section.querySelector('[data-raj-sp-variant-input]');
    const quantityInput = section.querySelector('[data-raj-sp-quantity-input]');
    const priceNode = section.querySelector('[data-raj-sp-price]');
    const compareNode = section.querySelector('[data-raj-sp-compare]');
    const discountNode = section.querySelector('[data-raj-sp-discount]');
    const addButton = section.querySelector('[data-raj-sp-add]');
    const addText = section.querySelector('[data-raj-sp-add-text]');
    const buyNowButton = section.querySelector('[data-raj-sp-buy-now]');
    const messageNode = section.querySelector('[data-raj-sp-message]');
    const sticky = section.querySelector('[data-raj-sp-sticky]');
    const stickyAdd = section.querySelector('[data-raj-sp-sticky-add]');
    const stickyAddText = section.querySelector('[data-raj-sp-sticky-add-text]');
    const stickyPrice = section.querySelector('[data-raj-sp-sticky-price]');
    const stickyCompare = section.querySelector('[data-raj-sp-sticky-compare]');
    const stickySave = section.querySelector('[data-raj-sp-sticky-save]');
    const optionButtons = Array.from(section.querySelectorAll('[data-raj-sp-option]'));
    const optionValueLabels = Array.from(section.querySelectorAll('[data-raj-sp-option-value]'));
    const stickyOptionSelect = section.querySelector('[data-raj-sp-sticky-option]');
    const copyCoupon = section.querySelector('[data-raj-sp-copy-coupon]');
    const couponCode = section.querySelector('[data-raj-sp-coupon-code]');
    const qtyValue = section.querySelector('[data-raj-sp-qty-value]');
    const qtyMinus = section.querySelector('[data-raj-sp-qty-minus]');
    const qtyPlus = section.querySelector('[data-raj-sp-qty-plus]');
    const thumbScroller = section.querySelector('[data-raj-sp-thumbs]');
    const thumbPrev = section.querySelector('[data-raj-sp-thumb-prev]');
    const thumbNext = section.querySelector('[data-raj-sp-thumb-next]');
    const thumbs = Array.from(section.querySelectorAll('[data-raj-sp-thumb]'));
    const mediaItems = Array.from(section.querySelectorAll('[data-raj-sp-media]'));

    const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
    const checkoutUrl = section.dataset.checkoutUrl || '/checkout';

    let variants = [];
    let moneyFormat = '${{amount}}';
    let quantity = 1;
    let currentVariant = null;

    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    try {
      moneyFormat = JSON.parse(moneyNode.textContent || '"${{amount}}"');
    } catch (error) {
      moneyFormat = '${{amount}}';
    }

    const isMobileThumbs = () => window.matchMedia('(max-width: 989px)').matches;

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      const amount = (Number(cents || 0) / 100).toFixed(2);
      return `₹${amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    };

    const updateThumbNavState = () => {
      if (!thumbScroller || !thumbPrev || !thumbNext) return;

      const axis = isMobileThumbs() ? 'x' : 'y';
      const current = axis === 'x' ? thumbScroller.scrollLeft : thumbScroller.scrollTop;
      const max = axis === 'x'
        ? thumbScroller.scrollWidth - thumbScroller.clientWidth
        : thumbScroller.scrollHeight - thumbScroller.clientHeight;

      thumbPrev.classList.toggle('is-disabled', current <= 2);
      thumbNext.classList.toggle('is-disabled', current >= max - 2 || max <= 0);
    };

    const scrollThumbs = (direction) => {
      if (!thumbScroller) return;

      const amount = isMobileThumbs() ? 220 : 230;

      thumbScroller.scrollBy({
        left: isMobileThumbs() ? direction * amount : 0,
        top: isMobileThumbs() ? 0 : direction * amount,
        behavior: 'smooth'
      });

      window.setTimeout(updateThumbNavState, 260);
    };

    const activateMedia = (index) => {
      thumbs.forEach((thumb) => {
        const active = Number(thumb.dataset.mediaIndex) === Number(index);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');

        if (active && thumbScroller) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });

      mediaItems.forEach((media) => {
        const active = Number(media.dataset.mediaIndex) === Number(index);
        media.classList.toggle('is-active', active);

        const video = media.querySelector('video');
        if (video && !active) {
          video.pause();
        }
      });

      const activeMedia = mediaItems.find((media) => Number(media.dataset.mediaIndex) === Number(index));
      const activeVideo = activeMedia ? activeMedia.querySelector('video') : null;

      if (activeVideo) {
        const promise = activeVideo.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => {});
        }
      }

      window.setTimeout(updateThumbNavState, 120);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        activateMedia(thumb.dataset.mediaIndex);
      });
    });

    if (thumbPrev) {
      thumbPrev.addEventListener('click', () => scrollThumbs(-1));
    }

    if (thumbNext) {
      thumbNext.addEventListener('click', () => scrollThumbs(1));
    }

    if (thumbScroller) {
      thumbScroller.addEventListener('scroll', updateThumbNavState, { passive: true });
    }

    const selectedOptions = () => {
      const groups = Array.from(section.querySelectorAll('[data-raj-sp-option-group]'));

      return groups
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((group) => {
          const active = group.querySelector('[data-raj-sp-option].is-active');
          return active ? active.dataset.optionValue : '';
        });
    };

    const findVariant = () => {
      const selected = selectedOptions();
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selected[index]);
      }) || null;
    };

    const setMessage = (text) => {
      if (!messageNode) return;

      if (text) {
        messageNode.textContent = text;
        messageNode.hidden = false;
      } else {
        messageNode.textContent = '';
        messageNode.hidden = true;
      }
    };

    const updatePrice = (variant) => {
      if (!variant) return;

      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);
      const hasCompare = compare > price;
      const discount = hasCompare ? Math.round(((compare - price) * 100) / compare) : 0;
      const save = hasCompare ? compare - price : 0;

      if (priceNode) priceNode.textContent = formatMoney(price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);

      if (compareNode) {
        compareNode.textContent = hasCompare ? formatMoney(compare) : '';
        compareNode.classList.toggle('is-hidden', !hasCompare);
      }

      if (stickyCompare) {
        stickyCompare.textContent = hasCompare ? formatMoney(compare) : '';
        stickyCompare.classList.toggle('is-hidden', !hasCompare);
      }

      if (discountNode) {
        discountNode.textContent = hasCompare ? `${discount}% off` : '';
        discountNode.classList.toggle('is-hidden', !hasCompare);
      }

      if (stickySave) {
        stickySave.textContent = hasCompare ? `Save ${formatMoney(save)}` : '';
        stickySave.classList.toggle('is-hidden', !hasCompare);
      }
    };

    const updateAvailability = (variant) => {
      const available = Boolean(variant && variant.available);

      if (variantInput && variant) {
        variantInput.value = variant.id;
        variantInput.disabled = !available;
      }

      [addButton, buyNowButton, stickyAdd].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });

      const soldOutText = 'SOLD OUT';
      const addTextValue = 'ADD TO CART';

      if (addText) addText.textContent = available ? addTextValue : soldOutText;
      if (stickyAddText) stickyAddText.textContent = available ? addTextValue : soldOutText;
    };

    const updateUrl = (variant) => {
      if (!variant || !window.history || !window.history.replaceState) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    const updateOptionLabels = () => {
      optionValueLabels.forEach((label) => {
        const position = label.dataset.rajSpOptionValue;
        const active = section.querySelector(`[data-raj-sp-option][data-option-position="${position}"].is-active`);
        if (active) label.textContent = active.dataset.optionValue || '';
      });
    };

    const updateStickyOption = () => {
      if (!stickyOptionSelect) return;

      const position = stickyOptionSelect.dataset.optionPosition;
      const active = section.querySelector(`[data-raj-sp-option][data-option-position="${position}"].is-active`);

      if (active) {
        stickyOptionSelect.value = active.dataset.optionValue;
      }
    };

    const updateDisabledOptions = () => {
      const selected = selectedOptions();

      optionButtons.forEach((button) => {
        const position = Number(button.dataset.optionPosition);
        const value = button.dataset.optionValue;
        const testOptions = [...selected];

        testOptions[position - 1] = value;

        const hasAvailableMatch = variants.some((variant) => {
          if (!variant.available) return false;

          return variant.options.every((option, index) => {
            return !testOptions[index] || option === testOptions[index];
          });
        });

        button.classList.toggle('is-disabled', !hasAvailableMatch);
        button.setAttribute('aria-disabled', hasAvailableMatch ? 'false' : 'true');
      });
    };

    const updateVariantMedia = (variant) => {
      if (!variant || !variant.featured_media || !variant.featured_media.id) return;

      const mediaIndex = mediaItems.findIndex((media) => {
        return String(media.dataset.rajSpMediaId) === String(variant.featured_media.id);
      });

      if (mediaIndex >= 0) {
        activateMedia(mediaIndex);
      }
    };

    const updateVariant = () => {
      const variant = findVariant();
      currentVariant = variant;

      updateOptionLabels();
      updateStickyOption();
      updateDisabledOptions();

      if (!variant) {
        updateAvailability(null);
        return;
      }

      updatePrice(variant);
      updateAvailability(variant);
      updateUrl(variant);
      updateVariantMedia(variant);
    };

    const setQuantity = (nextQuantity) => {
      quantity = Math.max(1, Number(nextQuantity) || 1);

      if (qtyValue) qtyValue.textContent = quantity;
      if (quantityInput) quantityInput.value = quantity;
    };

    const getCartDrawer = () => document.querySelector('cart-drawer');

    const openCartDrawer = (data, activeElement) => {
      document.dispatchEvent(new CustomEvent('raj:cart:open'));
      document.dispatchEvent(new CustomEvent('raj:cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      const cartDrawer = getCartDrawer();

      if (!cartDrawer) return;

      if (data && data.sections && typeof cartDrawer.renderContents === 'function') {
        if (typeof cartDrawer.setActiveElement === 'function' && activeElement) {
          cartDrawer.setActiveElement(activeElement);
        }

        cartDrawer.renderContents(data);
        return;
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open(activeElement || undefined);
      }
    };

    const parseCartError = async (response) => {
      try {
        const data = await response.json();
        return data.description || data.message || 'Unable to add this product.';
      } catch (error) {
        return 'Unable to add this product.';
      }
    };

    const addToCart = async ({ checkout = false, trigger = null } = {}) => {
      if (!currentVariant || !currentVariant.available || form.dataset.loading === 'true') return;

      form.dataset.loading = 'true';
      setMessage('');

      const originalAddText = addText ? addText.textContent : '';
      const originalStickyText = stickyAddText ? stickyAddText.textContent : '';

      if (addText) addText.textContent = 'ADDING...';
      if (stickyAddText) stickyAddText.textContent = 'ADDING...';

      [addButton, buyNowButton, stickyAdd].forEach((button) => {
        if (button) button.disabled = true;
      });

      try {
        const formData = new FormData();
        formData.append('id', currentVariant.id);
        formData.append('quantity', quantity);

        const cartDrawer = getCartDrawer();

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        const response = await fetch(cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: formData
        });

        let data = null;

        try {
          data = await response.json();
        } catch (error) {
          data = null;
        }

        if (!response.ok || (data && data.status)) {
          throw new Error((data && (data.description || data.message)) || await parseCartError(response));
        }

        if (checkout) {
          window.location.href = checkoutUrl;
          return;
        }

        if (addText) addText.textContent = 'ADDED';
        if (stickyAddText) stickyAddText.textContent = 'ADDED';

        openCartDrawer(data, trigger || addButton);

        window.setTimeout(() => {
          if (addText) addText.textContent = originalAddText || 'ADD TO CART';
          if (stickyAddText) stickyAddText.textContent = originalStickyText || 'ADD TO CART';
        }, 900);
      } catch (error) {
        setMessage(error.message || 'Unable to add this product.');

        if (addText) addText.textContent = originalAddText || 'ADD TO CART';
        if (stickyAddText) stickyAddText.textContent = originalStickyText || 'ADD TO CART';
      } finally {
        window.setTimeout(() => {
          form.dataset.loading = 'false';

          [addButton, buyNowButton, stickyAdd].forEach((button) => {
            if (button) button.disabled = !(currentVariant && currentVariant.available);
          });
        }, 350);
      }
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.classList.contains('is-disabled')) return;

        const position = button.dataset.optionPosition;
        const groupButtons = section.querySelectorAll(`[data-raj-sp-option][data-option-position="${position}"]`);

        groupButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        updateVariant();
      });
    });

    if (stickyOptionSelect) {
      stickyOptionSelect.addEventListener('change', () => {
        const position = stickyOptionSelect.dataset.optionPosition;
        const value = stickyOptionSelect.value;
        const button = section.querySelector(`[data-raj-sp-option][data-option-position="${position}"][data-option-value="${CSS.escape(value)}"]`);

        if (button) button.click();
      });
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', () => setQuantity(quantity - 1));
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', () => setQuantity(quantity + 1));
    }

    if (copyCoupon && couponCode) {
  const resetCouponCopyState = () => {
    copyCoupon.classList.remove('is-copied');
    copyCoupon.removeAttribute('title');
    copyCoupon.setAttribute('aria-label', 'Copy coupon code');
  };

  const showCouponCopiedState = () => {
    window.clearTimeout(copyCoupon._rajCouponTimer);

    copyCoupon.classList.add('is-copied');
    copyCoupon.setAttribute('aria-label', 'Coupon code copied');
    copyCoupon.setAttribute('title', 'Copied');

    copyCoupon._rajCouponTimer = window.setTimeout(() => {
      resetCouponCopyState();
    }, 1500);
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);

    if (!copied) {
      throw new Error('Copy failed');
    }
  };

  copyCoupon.addEventListener('click', async () => {
    const code = couponCode.textContent.trim();

    if (!code) return;

    try {
      await copyTextToClipboard(code);
      showCouponCopiedState();
    } catch (error) {
      resetCouponCopyState();
    }
  });
}

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addToCart({ checkout: false, trigger: addButton });
      });
    }

    if (buyNowButton) {
      buyNowButton.addEventListener('click', () => {
        addToCart({ checkout: true, trigger: buyNowButton });
      });
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', () => {
        addToCart({ checkout: false, trigger: stickyAdd });
      });
    }

    const updateSticky = () => {
      if (!sticky) return;

      const shouldShow = window.scrollY > 620;
      sticky.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('raj-sp-sticky-active', shouldShow);
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', () => {
      updateSticky();
      updateThumbNavState();
    });

    setQuantity(1);
    activateMedia(0);
    currentVariant = findVariant() || variants.find((variant) => variant.available) || variants[0] || null;
    updateVariant();
    updateSticky();
    updateThumbNavState();
  };

  const initAll = () => {
    document.querySelectorAll('[data-raj-single-product]').forEach(initRajSingleProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();